import { Grid, Typography, Box } from "@material-ui/core";
import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import yooz_pp from "../../assets/documents/yooz_pp.pdf";
import yooz_tac from "../../assets/documents/yooz_tac.pdf";

const useStyles = makeStyles((theme) => ({
  copyright: {
    textAlign: "center",
    color: "#FFF",
    background: "#000617",
    padding: 5,
    width: "100%",
    position:"absolute",
    bottom:0,
    zIndex: theme.zIndex.drawer + 1,
  },
}));

function ListItemLinkA(props) {
  return (
    <Link
      href={props.path}
      target="_blank"
      rel="noopener"
      style={{
        color: "#fff",
      }}
    >
      <Typography variant={"caption"}>{props.text}</Typography>
    </Link>
  );
}
export default function SecuredAppFooter() {
  const classes = useStyles();

  return (
    <Box mt={3} className={classes.copyright}>
      <Grid container>
        <Grid item xs={6} md={3}>
          <ListItemLinkA path={yooz_tac} text="Terms and Conditions" />
        </Grid>
        <Grid item xs={6} md={3}>
          <ListItemLinkA path={yooz_pp} text="Privacy Policy" />
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="caption">
            Copyright {"© "}
            YOOZ. All Rights Reserved{" "}
            {new Date().getFullYear()}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
